import { store } from "@/store";
import { Roles } from "@/helpers/enums/Roles";

export default [
  {
    path: "home",
    component: () => import("@/views/pages/Policy/Home.vue"),
    meta: {
      title: "policyHome",
    },
  },
  {
    path: "new",
    component: () => import("@/views/pages/Policy/ManageElectives.vue"),
    meta: {
      title: "policyHome",
    },
  },
  {
    path: "show",
    component: () => import("@/views/pages/Policy/ShowPolicy.vue"),
    meta: {
      title: "Sql Server",
      breadcrumbs: [
        {
          route: "spm-global",
          title: "policyHome",
        },
      ],
    },
  },
  {
    path: "spm-global",
    name: "spm-global",
    component: () => import("@/views/pages/Policy/SpmGlobal.vue"),
    meta: {
      title: "spmGlobalManagement",
    },
  },

  {
    path: "shared-policy-topology",
    name: "shared-policy-topology",
    component: () => import("@/views/pages/Policy/SharedTopology.vue"),
    meta: {
      title: "spmGlobalManagement",
    },
  },

  {
    path: "shared-policy-topology",
    name: "shared-policy-topology",
    component: () => import("@/views/pages/Policy/SharedTopology.vue"),
    meta: {
      title: "spmGlobalManagement",
    },
  },
  {
    path: "service-provider-level",
    name: "service-provider-level",
    component: () => import("@/views/pages/Policy/ServiceProviderLevel.vue"),
    meta: {
      title: "Service Provider Level",
    
    },
  },
  {
    path: "top-level-electives",
    name: "top-level-electives",
    component: () => import("@/views/pages/Policy/TopLevelElectives.vue"),
    meta: {
      title: "Service Provider Level",
    
    },
  },
  {
    path: "spm-local",
    component: () => import("@/views/pages/Policy/SpmLocal.vue"),
    meta: {
      title: "spmLocal",
    },
  },
  {
    path: "iconset",
    component: () => import("@/views/pages/Policy/Icons.vue"),
    meta: {
      title: "spmLocal",
    },
  },
];
